export function getRecaptchaSiteKey() {
  return process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
}

